import React from 'react';
import { Card } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import styles from './InfoCard.less';

export interface InfoCardProps {
  title: React.ReactNode | string;
  className?: string;
  headerClassName?: string;
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'blue' | 'purple';
  extra?: React.ReactNode;
  style?: React.StyleHTMLAttributes<any>;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  children,
  className,
  style = {},
  headerClassName,
  onClick,
  variant = 'blue',
  extra,
}) => {
  return (
    <Card
      className={classNames(className, styles.infoCard, styles[variant], {
        [styles.clickable]: onClick,
      })}
      style={style}
      onClick={onClick}
    >
      <div className={classNames(styles.header, headerClassName)}>
        <h3 className={classNames(styles.title, styles[`title__${variant}`])}>
          {title}
        </h3>
        <div className={styles.headerExtra}>
          {extra}
          {onClick && <RightOutlined className={styles.arrow} />}
        </div>
      </div>
      <div className={styles.content}>{children}</div>
    </Card>
  );
};

export default InfoCard;
